import { defineStore } from "pinia";
import type { OpenMembershipFullscreenOptions } from "./types";

/** 独立且不持久化的展示状态，不读写旧 productModalState。 */
export const useMembershipFullscreenStore = defineStore("membershipFullscreen", {
  state: () => ({
    mounted: false,
    open: false,
    highlightMemberType: undefined as OpenMembershipFullscreenOptions["highlightMemberType"],
    initialPeriod: undefined as OpenMembershipFullscreenOptions["initialPeriod"],
    initialTab: undefined as OpenMembershipFullscreenOptions["initialTab"]
  }),
  actions: {
    show(options: OpenMembershipFullscreenOptions = {}) {
      // 关闭动画结束前也不重入，防止旧 afterClose 清除新实例。
      if (this.mounted) return;
      this.highlightMemberType = options.highlightMemberType;
      this.initialPeriod = options.initialPeriod;
      this.initialTab = options.initialTab;
      this.mounted = true;
      this.open = true;
    },
    close() {
      this.open = false;
    },
    release() {
      this.$reset();
    }
  }
});
